import { render, staticRenderFns } from "./UserWebhooks.vue?vue&type=template&id=0430ffda"
import script from "./UserWebhooks.vue?vue&type=script&lang=js"
export * from "./UserWebhooks.vue?vue&type=script&lang=js"
import style0 from "./UserWebhooks.vue?vue&type=style&index=0&id=0430ffda&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports